import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonV2 } from 'shared';
import { Plus } from 'images/svg-components';
function LinkDifferentAccountButton({ onClick, className = '', }) {
    return (_jsx(ButtonV2, { type: "button", variant: "ghost", color: "black", size: "medium", hugText: true, overwriteCasing: true, SvgIcon: Plus, onClick: onClick, className: className, children: "Link a Different Bank Account" }));
}
export default LinkDifferentAccountButton;
